import { IHasPropertyEditorProps } from '../contexts/PropertyEditorContext';

export function getEditingContext(props: IHasPropertyEditorProps) {
  if (!props.editingContextId && !props.snapshot && !props.loading?.isLoading) {
    throw new Error('PropertyGrid or similar must have either a `snapshot`, or an `editingContextId` provided.');
  }

  return props.editingContextId || props.snapshot?.EditingContextId || '';
}
